"use strict";

var PropTypes = require("prop-types");

var classNames = require("classnames");
var LoggerInstance = require("js-logger").get("CountrySelector");

var AccountActions = require("./AccountActions");
var AccountFormHelper = require("./AccountFormHelper");
var AccountStore = require("./AccountStore");

class CountrySelector extends React.Component {
	constructor(props) {
		super(props);

		var countryConfig = props.countryConfig || {};
		var availableCountries = countryConfig.availableCountries || [];
		var selectedCountry;
		var wizardCountryList;
		var allowedAvailableCountries;
		var wizardCountryList;

		// If we are on the client side
		if (typeof (window) !== "undefined") {
			wizardCountryList = AccountStore.get("wizardCountryList");

			if (!countryConfig.availableCountries) {
				//This means we do not have the config set up yet.
				countryConfig = {
					defaultCountry: wizardCountryList.defaultCountry,
					availableCountries: wizardCountryList.availableCountries.map(availableCountry => {
						return {
							value: availableCountry,
							description: wizardCountryList[`${availableCountry}_Description`],
							useDefaultDescription: true
						};
					})
				};
			}

			availableCountries = countryConfig.availableCountries ? countryConfig.availableCountries.slice(0) : []; // clone the array to avoid reference

			if (wizardCountryList) {
				allowedAvailableCountries = wizardCountryList.availableCountries || [];
			}
		}

		if (allowedAvailableCountries) {
			var availableCountry;
			for (var index = availableCountries.length - 1; index >= 0; --index) {
				availableCountry = availableCountries[index];
				var allowedIndex = allowedAvailableCountries.indexOf(availableCountry.value);
				if (allowedIndex === -1) {
					// AvailableCountry is not allowed
					availableCountries.splice(index, 1);
				} else if (availableCountry.useDefaultDescription) {
					// AvailableCountry should use default description
					availableCountry.description = wizardCountryList[`${availableCountry.value}_Description`];
				}
			}
		}

		if (!selectedCountry) {
			selectedCountry = props.initialValue || countryConfig.defaultCountry || (availableCountries.length > 0 ? availableCountries[0].value : "");
		}

		this.state = {
			availableCountries,
			selectedCountry,
			disabled: false
		};

		this._onChange = this._onChange.bind(this);
	}

	handleCountrySelected(event) {
		if (!event || !event.currentTarget) {
			return;
		}

		var selectedCountry = event.currentTarget.value;
		var formParentId = AccountFormHelper.getParentFormId(this);

		AccountActions.setSelectedCountry(formParentId, selectedCountry);
	}

	_onChange() {
		if (this._isMounted) {
			var formParentId = AccountFormHelper.getParentFormId(this);
			this.setState({
				selectedCountry: AccountActions.getSelectedCountry(formParentId),
				disabled: formParentId ? AccountActions.getIsFormInputDisabled(formParentId) : false
			});
		}
	}

	componentDidMount() {
		this._isMounted = true;

		if (this.props.isDesignMode) {
			//To add or remove react components from window, edit wwwroot\js\designer\ExposedComponents.jsx
			parent.window.ComponentActions.childComponentLoaded(this);
		}

		// At this point, selectedCountry has been set by the component
		var $formParent = AccountFormHelper.getParentForm(this);
		var formParentId = AccountFormHelper.getParentFormIdFromForm($formParent);
		var updateAllowed = true;

		if ($formParent.length > 0) {
			// updateAllowed only applies to createAccountForm
			updateAllowed = !$formParent.is("[data-component='createAccountForm']") || $formParent.is("[data-update-allowed]");
		}

		AccountActions.setSelectedCountry(formParentId, this.state.selectedCountry);
		AccountStore.addChangeListener(this._onChange);
		AccountActions.toggleInputStatus(formParentId, /*disabled*/ !updateAllowed);
	}

	componentWillUnmount() {
		AccountStore.removeChangeListener(this._onChange);
		if (this.props.isDesignMode) {
			//To add or remove react components from window, edit wwwroot\js\designer\ExposedComponents.jsx
			parent.window.ComponentActions.childComponentUnloaded(this);
			var $formParent = AccountFormHelper.getParentForm(this);
			var formParentId = AccountFormHelper.getParentFormIdFromForm($formParent);
			var updateAllowed = true;

			if ($formParent.length > 0) {
				updateAllowed = $formParent.is("[data-update-allowed]");
			}

			AccountActions.setSelectedCountry(formParentId, null);
			AccountActions.toggleInputStatus(formParentId, /*disabled*/ !updateAllowed);
		}

		this._isMounted = false;
	}

	render() {
		return (
			<div
				data-react-component-name="CountrySelector"
				data-component-id={!this.props.isCustomTheme ? this.props.dataComponentId : undefined}
				data-nested-id={this.props.dataNestedId}
				data-repeated-id={this.props.dataRepeatedId}
				data-theme={+this.props.theme ? this.props.theme : undefined}
				data-custom={this.props.isCustomTheme || null}
				data-child-of={this.props.dataChildOf}
				data-react-component-category={this.props.reactComponentCategory}
			>
				<select
					className={classNames("country-selector form-control", this.props.childClass)}
					style={this.props.isDesignMode ? {"pointerEvents": "none"} : undefined}
					data-override-classes={this.props.childClass}
					name="address.country"
					onChange={this.handleCountrySelected.bind(this)}
					data-required={this.props.dataRequired}
					required={this.props.required || this.props.dataRequired}
					value={this.state.selectedCountry}
					disabled={this.state.disabled}
				>
					{this.state.availableCountries.map((availableCountry) => {
						return (
							<option className="availableCountry" key={availableCountry.value} value={availableCountry.value}>
								{availableCountry.description}
							</option>
						);
					})}
				</select>
			</div>
		);
	}
}

CountrySelector.propTypes = {
	isDesignMode: PropTypes.bool,
	countryConfig: PropTypes.object,
	dataRequired: PropTypes.bool,
	required: PropTypes.bool,
	theme: PropTypes.string,
	context: PropTypes.string,
	isCustomTheme: PropTypes.bool,
	childClass: PropTypes.string,
	dataComponentId: PropTypes.string,
	dataNestedId: PropTypes.string,
	dataRepeatedId: PropTypes.string,
	reactComponentCategory: PropTypes.string,
	initialValue: PropTypes.string,
	dataChildOf: PropTypes.string
};

module.exports = CountrySelector;
